import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';

import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';

import * as styles from './publication-field-label.scss';

type PropsType = {
    labelLangKey: LangKeyType;
    tooltipLangKey: LangKeyType;
};

// Form-field label with an info-tooltip icon rendered to the LEFT of the label text.
// Used only for fields that need an extra explanation (e.g. the difference between the
// event/promotion active period and the publication display period).
export function PublicationFieldLabel({labelLangKey, tooltipLangKey}: PropsType): JSX.Element {
    return (
        <span className={styles.PublicationFieldLabel}>
            <Tooltip title={<Locale stringKey={tooltipLangKey} />}>
                <span className={styles.PublicationFieldLabel_icon}>
                    <FontAwesomeIcon icon={faCircleInfo} />
                </span>
            </Tooltip>
            <Locale stringKey={labelLangKey} />
        </span>
    );
}
